(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-custom-card-quickadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var done = function () {
      btn.textContent = originalText;
      btn.disabled = false;
    };

    if (window.UKPSCart && window.UKPSCart.addToCart) {
      window.UKPSCart.addToCart(variantId, 1).then(done).catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        btn.textContent = '✓ Added';
        setTimeout(done, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  });
})();
